import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgEmail(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M20 2v12H4V2zm-2 3.17l-6.02 5.147L6 5.178V12h12zM16.29 4H7.698l4.286 3.683z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Email')(SvgEmail);
